module.exports = __webpack_public_path__ + "static/media/Paulo-image.72cf6146.png";